// Constantes compartidas entre schemas.
// El guion al final del character class no necesita escape; ponerlo
// al final lo hace literal.
export const CODIGO_LOTE_MAX_LENGTH = 20;
export const CODIGO_LOTE_REGEX = /^[A-Za-z0-9-]{3,20}$/;
